import { memo } from 'react'
import type { RateInfo } from '../../types/electricity'
import { RATES } from '../../data/rates'
import { useLanguage } from '../../i18n/LanguageContext'
import { PulsingDot } from './PulsingDot'
import { RateLabel } from './RateLabel'

export const RateGauge = memo(function RateGauge({ rate }: { rate: RateInfo }) {
  const { t } = useLanguage()
  const radius = 80
  const circumference = Math.PI * radius
  const minRate = RATES.transition.offpeak
  const maxRate = RATES.summer.peak
  const normalized = Math.max(0, Math.min(1, (rate.rateAgorot - minRate) / (maxRate - minRate)))
  const offset = circumference * (1 - normalized)

  const isPeak = rate.tier === 'peak'
  const gradientId = isPeak ? 'gaugeGradientRed' : 'gaugeGradientGreen'
  const startColor = isPeak ? '#ef4444' : '#34d399'
  const endColor = isPeak ? '#f87171' : '#6ee7b7'

  return (
    <div>
      <div className="flex justify-center mb-2">
        <PulsingDot tier={rate.tier} />
      </div>

      <div className="flex justify-center">
        <svg width="220" height="130" viewBox="0 0 220 130">
          <defs>
            <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor={startColor} />
              <stop offset="100%" stopColor={endColor} />
            </linearGradient>
          </defs>

          <path
            d="M 20 120 A 80 80 0 0 1 200 120"
            fill="none"
            stroke="rgba(255,255,255,0.08)"
            strokeWidth="14"
            strokeLinecap="round"
          />

          <path
            d="M 20 120 A 80 80 0 0 1 200 120"
            fill="none"
            stroke={`url(#${gradientId})`}
            strokeWidth="14"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            className="animate-gauge-fill"
            style={{ transition: 'stroke-dashoffset 1s ease-out' }}
          />

          <text x="110" y="85" textAnchor="middle" className="font-heading" fill="white" fontSize="32" fontWeight="700">
            {rate.rateShekel.toFixed(2)}
          </text>
          <text x="110" y="110" textAnchor="middle" fill="#94a3b8" fontSize="12">
            {t('rate.perKwh') as string}
          </text>
        </svg>
      </div>

      <RateLabel rate={rate} />
    </div>
  )
})
